import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import IdentificationPage from "./pages/IdentificationPage";
import ChangeEmailPage from "./pages/ChangeEmailPage";
import ChangeMobilePage from "./pages/ChangeMobilePage";
import ChangePhonePage from "./pages/ChangePhonePage";

interface IProps {}

const Customer: React.FC<IProps> = (props) => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/change-phone`} component={ChangePhonePage} />
      <Route path={`${match.path}/change-mobile`} component={ChangeMobilePage} />
      <Route path={`${match.path}/change-email`} component={ChangeEmailPage} />
      <Route path={match.path} component={IdentificationPage} />
    </Switch>
  );
};

export default Customer;
